

const processError = require('./error-process');

module.exports = (space, entryId) => {
  return space.getEntry(entryId).catch(
    processError
  );
};
